import { render } from "./PageColumn.vue?vue&type=template&id=5b2b177e&ts=true&lang=pug"
import script from "./PageColumn.vue?vue&type=script&lang=ts"
export * from "./PageColumn.vue?vue&type=script&lang=ts"

import "./PageColumn.vue?vue&type=style&index=0&id=5b2b177e&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__